export const OutOfRangeErrorCode = "out-of-range";
export const InvalidDocumentErrorCode = "invalid-document";
/**
 * See also the error codes system in constants and core - these are earlier because they're used by repositories
 */
const errorCodes = [OutOfRangeErrorCode, InvalidDocumentErrorCode];
export class ErrorWithCode extends Error {
    code;
    constructor(message, code, cause) {
        super(message, { cause });
        this.code = code;
    }
}
export class OutOfRangeError extends ErrorWithCode {
    constructor(message, { cause } = {}) {
        super(message, OutOfRangeErrorCode, cause);
    }
}
export class InvalidDocumentError extends ErrorWithCode {
    constructor(message, { cause } = {}) {
        super(message, InvalidDocumentErrorCode, cause);
    }
}
//# sourceMappingURL=errors.js.map